import React from 'react'

export default function NotificationComponent() {
  return (
    <div>Notification List Page</div>
  )
}
